import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import ModalVideo from 'react-modal-video';

// ES6 class-style
class VideoComponent extends PreLoginSessionCheck {
  

  constructor (props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.openModal = this.openModal.bind(this)
    this.goNext = this.goNext.bind(this)
    this.goPrev = this.goPrev.bind(this)
    this.swiper = null
  }

  goNext() {
    if (this.swiper) this.swiper.slideNext()
  }
 
  goPrev() {
    if (this.swiper) this.swiper.slidePrev()
  }

  openModal (someValue) {
    this.setState({isOpen: true})
    this.videoId = someValue
    console.log(this.videoId);
  }

  render() {
  	const videoId = '';
	const params = {
		slidesPerView: 1,
	 	spaceBetween: 30,
	 	loop: false,
	 	navigation: {
	        nextEl: '.swiper-button-next',
	        prevEl: '.swiper-button-prev',
	        nextButtonCustomizedClass:'.swp-next',
	    	prevButtonCustomizedClass:'.swp-prev'	
	    },
	    breakpoints: {
		    480: {
		      slidesPerView: 1,
		      spaceBetween: 20
		    },
		    640: {
		      slidesPerView: 1,
		      spaceBetween: 30
		    },
		    768: {
		      slidesPerView: 1,
		      spaceBetween: 30
		    }
		}
    } 

  	return(
  	<section className="mtb video-container">
		<div className="row">
			<div className="container">
				{/* <Swiper className="student-slider" slidesPerView={params.slidesPerView}  breakpoints={params.breakpoints} loop={params.loop} spaceBetween={params.spaceBetween} ref={node => {if(node) this.swiper = node.swiper} }> */}
					
					<div data-ga="Home - How HeyMath! really empowers Tutors and Teachers" className="swiper-slide">
						<div className="img-box popup-youtube single-video" onClick={this.openModal.bind(null,'IA_Pal7iRmE')}>
							<img src="../img/teacherBanner.jpg" alt="How HeyMath! really empowers Tutors and Teachers"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
				{/* </Swiper> */}
				{/* <div className="slider-btns">
	        		<div className="swiper-button-prev swp-prev" onClick={this.goPrev}></div>
	        		<div className="swiper-button-next swp-next"  onClick={this.goNext}></div>
        		</div> */}
			</div> 
		</div>
		<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.videoId} onClose={() => this.setState({isOpen: false})} /> 
	</section>
  	);
  }
}

export default VideoComponent;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/VideoComponent.js